/* eslint-disable linebreak-style */

import { isFeatureEnabled } from '../config/featureFlags';
import { messages } from './messages';

export const DEFAULT_LOCALE = 'ro';
export const FALLBACK_LOCALE = 'en';
export const LOCALE_STORAGE_KEY = 'larex_locale';
export const LOCALE_CHANGED_EVENT = 'larex_locale_changed';

const resolveLocale = (localeCandidate)=>{
  const normalized = String(localeCandidate || '').trim().toLowerCase();
  if (messages[normalized]) {
    return normalized;
  }
  return DEFAULT_LOCALE;
};

const getPathValue = (objectValue, path)=>{
  return String(path || '')
    .split('.')
    .filter(Boolean)
    .reduce((accumulator, key)=>{
      if (accumulator && Object.prototype.hasOwnProperty.call(accumulator, key)) {
        return accumulator[key];
      }
      return undefined;
    }, objectValue);
};

const formatTemplate = (template, params = {})=>{
  if (typeof template !== 'string') {
    return '';
  }
  return template.replace(/\{(\w+)\}/g, (_, key)=>{
    if (Object.prototype.hasOwnProperty.call(params, key)) {
      return String(params[key]);
    }
    return `{${key}}`;
  });
};

export const getCurrentLocale = ()=>{
  if (!isFeatureEnabled('i18nMultilang')) {
    return DEFAULT_LOCALE;
  }
  try {
    if (typeof window !== 'undefined') {
      return resolveLocale(window.localStorage.getItem(LOCALE_STORAGE_KEY));
    }
  } catch (error) {
    return DEFAULT_LOCALE;
  }
  return DEFAULT_LOCALE;
};

export const setCurrentLocale = (locale)=>{
  const resolvedLocale = resolveLocale(locale);
  try {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(LOCALE_STORAGE_KEY, resolvedLocale);
      window.dispatchEvent(new CustomEvent(LOCALE_CHANGED_EVENT, {
        detail: { locale: resolvedLocale }
      }));
    }
  } catch (error) {
    return DEFAULT_LOCALE;
  }
  return resolvedLocale;
};

export const translate = (key, params = {}, fallbackText = '')=>{
  const locale = getCurrentLocale();
  const localizedValue = getPathValue(messages[locale], key);
  if (typeof localizedValue === 'string') {
    return formatTemplate(localizedValue, params);
  }
  const fallbackValue = getPathValue(messages[FALLBACK_LOCALE], key);
  if (typeof fallbackValue === 'string') {
    return formatTemplate(fallbackValue, params);
  }
  return fallbackText || key;
};

export const t = translate;

export const orderStatusLabel = (stadiu)=>{
  const value = String(stadiu || '').trim().toUpperCase();
  if (value === 'TRANSMISA') {
    return t('orderHeader.statusSent');
  }
  if (!value || value === 'NETRANSMISA') {
    return t('orderHeader.statusDefault');
  }
  return stadiu;
};
